import React, { useState, useEffect } from 'react';
import { useDeleteVehicleImageMutation, useGetVehicleQuery } from '../../Store/Apis/bookingApi';
import Loader from '../Loader/Loader';
import Error from '../Error/Error';
import { Modal } from 'react-bootstrap';

const AddEditVehicleDetails = ({ data, onSubmit, orderId, orderStatusId }) => {
    // Initialize state with API key names
    const [formData, setFormData] = useState({
        regNumber: '',
        vinNumber: '',
        kmRead: '',
        fuelRead: '',
        toolsSpare: '',
        scratchesDents: '',
        vehicleImages: [],
    });

    const [photoPreviews, setPhotoPreviews] = useState([]);

    


    // If data is passed through props, populate form fields
    useEffect(() => {
        if (data) {
            setFormData({
                regNumber: data.regNumber || '',
                vinNumber: data.vinNumber || '',
                kmRead: data.kmRead || '',
                fuelRead: data.fuelRead || '',
                toolsSpare: data.toolsSpare || '',
                scratchesDents: data.scratchesDents || '',
                vehicleImages: data.vehicleImages || [],
            });
        }
    }, [data]);

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle multiple file input changes and convert to base64
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const newImages = [];
    
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Image = reader.result;
                newImages.push({ vehicleImageID: null, vehicleImage: base64Image });
    
                // Update state after all files are processed
                if (newImages.length === files.length) {
                    setFormData((prevState) => ({
                        ...prevState,
                        vehicleImages: [...prevState.vehicleImages, ...newImages],
                    }));
                }
            };
            reader.readAsDataURL(file);
        });
    };

    // Handle removing an image
    const handleRemoveImage = (index) => {
        const updatedImages = [...formData.vehicleImages];
        updatedImages.splice(index, 1);
        setFormData({ ...formData, vehicleImages: updatedImages });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
    
        // Prepare payload: Include vehicleImageID only for updates
        const payload = {
            id: data.id,
            orderId,
            ...formData,
            vehicleImages: formData.vehicleImages.map((img) => ({
                vehicleImage: img.vehicleImage,
                ...(data && img.vehicleImageID && { vehicleImageID: img.vehicleImageID }),
            })),
        };
    
        onSubmit(payload);
    };


    // HANDLE DELETE VEHICLE IMAGE WHEN EDIT
    const [selectedVehicleImageRecord, setSelectedVehicleImageRecord] = useState(null);
    const [deleteVehicleImageMutation] = useDeleteVehicleImageMutation()
    const handleDeleteVehicleImageWhileEdit = (id) => {
        deleteVehicleImageMutation(id).then((res)=>{
            if(res.data.status == 200) {
                setFormData((prevState) => ({
                    ...prevState,
                    vehicleImages: prevState.vehicleImages.filter(
                        (image) => image.vehicleImageID !== id
                    ),
                }));
                setSelectedVehicleImageRecord(null);
            }
        })
    }

    console.log(orderStatusId)

    return (
        <form onSubmit={handleSubmit}>
            <div className="row gy-2">
                <div className="col-md-6">
                    <label htmlFor="regNumber" className="form-label">Registration Number</label>
                    <input
                        type="text"
                        className="form-control"
                        id="regNumber"
                        name="regNumber"
                        value={formData.regNumber}
                        onChange={handleChange}
                        required
                        disabled={orderStatusId !== 6}
                    />
                </div>

                <div className="col-md-6">
                    <label htmlFor="vinNumber" className="form-label">VIN Number</label>
                    <input
                        type="text"
                        className="form-control"
                        id="vinNumber"
                        name="vinNumber"
                        value={formData.vinNumber}
                        onChange={handleChange}
                        required
                        disabled={orderStatusId !== 6}
                    />
                </div>

                <div className="col-md-6">
                    <label htmlFor="kmRead" className="form-label">Kilometre Reading</label>
                    <input
                        type="number"
                        className="form-control"
                        id="kmRead"
                        name="kmRead"
                        value={formData.kmRead}
                        onChange={handleChange}
                        required
                        disabled={orderStatusId !== 6}
                    />
                </div>

                <div className="col-md-6">
                    <label htmlFor="fuelRead" className="form-label">Fuel Level</label>
                    <input
                        type="number"
                        className="form-control"
                        id="fuelRead"
                        name="fuelRead"
                        value={formData.fuelRead}
                        onChange={handleChange}
                        required
                        disabled={orderStatusId !== 6}
                    />
                </div>

                <div className="col-md-12">
                    <label htmlFor="toolsSpare" className="form-label">Car Tools & Spare Wheels</label>
                    <textarea
                        className="form-control"
                        id="toolsSpare"
                        name="toolsSpare"
                        rows="3"
                        value={formData.toolsSpare}
                        onChange={handleChange}
                        disabled={orderStatusId !== 6}
                    ></textarea>
                </div>

                <div className="col-md-12">
                    <label htmlFor="scratchesDents" className="form-label">Scratches & Dents</label>
                    <textarea
                        className="form-control"
                        id="scratchesDents"
                        name="scratchesDents"
                        rows="3"
                        value={formData.scratchesDents}
                        onChange={handleChange}
                        disabled={orderStatusId !== 6}
                    ></textarea>
                </div>

                <div className="col-md-12">
                    <label htmlFor="photos" className="form-label">Upload Photos</label>
                    <input
                        type="file"
                        className="form-control"
                        id="photos"
                        accept="image/*"
                        multiple
                        onChange={handleFileChange}
                        disabled={orderStatusId !== 6}
                    />

                    {formData.vehicleImages.length > 0 && (
                        <div className="mt-3 d-flex flex-wrap">
                            {formData.vehicleImages.map((img, index) => (
                                <div key={index} className="me-3 mb-3 text-center position-relative">
                                    <img
                                        src={img.vehicleImage}
                                        alt={`Preview ${index}`}
                                        className="img-thumbnail d-block"
                                        style={{ width: '80px', height: '80px' }}
                                    />
                                    <button
                                        type="button"
                                        className="btn mb-0 badge badge-xs badge-danger"
                                        onClick={() => (
                                            img.vehicleImageID
                                                ? handleDeleteVehicleImageWhileEdit(img.vehicleImageID)
                                                : handleRemoveImage(index)
                                        )}
                                        style={{ position: 'absolute', top: '6px', right: '6px', zIndex: '1' }}
                                        disabled={orderStatusId !== 6}
                                    >
                                        <i className="fa fa-times"></i>
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <button type="submit" className="btn btn-primary mt-4" disabled={orderStatusId !== 6}>
                {data ? 'Update Vehicle' : 'Add Vehicle'}
            </button>
        </form>
    );
};

export default AddEditVehicleDetails;
